let parameters = {
  content: {
      label: 'Title',
      source: 'parameters.never',
      items: [],
      types: [],
      item: {data: [], headers: []},
      class: 'xs12 sm12 d-flex',
      type: 'hidden',
      value: '<h2>Title</h2>',
      display: false,
      wait: false
  },
  chartDataSource: {
      label: 'Chart Data',
      class: 'xs12 sm12 d-flex',
      type: 'select',
      source: 'dataSources',
      itemValue: 'id',
      itemText: 'name',
      items: [],
      item: {data: [], headers: []},
      wait: false
  },
  groupData: {
      label: 'Group',
      class: 'xs12 sm12',
      type: 'select',
      source: 'parameters.chartDataSource.item.headers',
      itemText: 'text',
      itemValue: 'value',
      items: [],
      item: {},
      wait: false
  },
  itemData: {
      label: 'Item',
      class: 'xs12 sm6',
      type: 'select',
      source: 'parameters.chartDataSource.item.headers',
      itemText: 'text',
      itemValue: 'value',
      items: [],
      item: {},
      wait: false
  },
  transformItemData: {
      label: 'Format',
      class: 'xs12 sm6',
      type: 'select',
      source: 'parameters.transformItemData.aggregates',
      itemText: 'text',
      aggregates: [
        {aggregate: 'daily', text: 'Daily'},
        {aggregate: 'weekly', text: 'Weekly'},
        {aggregate: 'monthly', text: 'Monthly'},
        {aggregate: 'yearly', text: 'Anually'}
      ],
      itemValue: 'aggregate',
      value: 'sum',
      items: [],
      item: {},
      wait: false
  },
  valueData: {
      label: 'Value',
      class: 'xs12 sm6',
      type: 'select',
      source: 'parameters.chartDataSource.item.headers',
      itemText: 'text',
      itemValue: 'value',
      item: {},
      items: [],
      wait: false
  },
  transformValueData: {
      label: 'Aggregate',
      class: 'xs12 sm6',
      type: 'select',
      source: 'parameters.transformValueData.aggregates',
      itemText: 'text',
      //        aggregates: [
      //          {aggregate: 'sum(', text: 'Sum'},
      //          {aggregate: 'average(', text: 'Average'},
      //          {aggregate: 'min(', text: 'Minimum'},
      //          {aggregate: 'max(', text: 'Maximum'},
      //          {aggregate: 'count(', text: 'Count'},
      //          {aggregate: 'count(distinct ', text: 'Count Unique'}
      //        ],
              aggregates: [
                {aggregate: 'sum(num(', text: 'Sum'},
                {aggregate: 'average(num(', text: 'Average'},
                {aggregate: 'min(num(', text: 'Minimum'},
                {aggregate: 'max(num(', text: 'Maximum'},
                {aggregate: 'count(', text: 'Count'},
                {aggregate: 'count(distinct ', text: 'Count Unique'}
              ],
      itemValue: 'aggregate',
      value: 'sum(num(',
      items: [],
      item: {},
      wait: false
  },
    formatSource: {
        label: 'Format',
        class: 'xs6',
        type: 'select',
        source: 'parameters.formatSource.aggregates',
        itemText: 'text',
        aggregates: [
          {format: null, text: 'None'},
          {format: '0.00a', text: 'Value '},
          {format: '0o', text: 'Position'}
        ],
        itemValue: 'format',
        value: null,
        items: [],
        item: {data: [], headers: []},
        wait: false
    },
    currency: {
        label: 'Currency',
        class: 'xs6',
        type: 'select',
        source: 'parameters.currency.aggregates',
        itemText: 'text',
        aggregates: [
          {format: '', text: 'None'},
          {format: '£', text: '£ GBP'},
          {format: '$', text: '$ USD'}
        ],
        itemValue: 'format',
        value: '',
        items: [],
        item: {data: [], headers: []},
        wait: false
    },
    toolbarTheme: {
        label: 'Theme',
        class: 'xs6',
        type: 'select',
        source: 'parameters.toolbarTheme.themes',
        itemText: 'text',
        themes: [
          {value: 'red', text: 'Red'},
          {value: 'pink', text: 'Pink'},
          {value: 'purple', text: 'Purple'},
          {value: 'deep-purple', text: 'Deep Purple'},
          {value: 'indigo', text: 'Indigo'},
          {value: 'blue', text: 'Blue'},
          {value: 'light-blue', text: 'Light Blue'},
          {value: 'cyan', text: 'Cyan'},
          {value: 'teal', text: 'Teal'},
          {value: 'green', text: 'Green'},
          {value: 'light-green', text: 'Light Green'},
          {value: 'lime', text: 'Lime'},
          {value: 'yellow', text: 'Yellow'},
          {value: 'amber', text: 'Amber'},
          {value: 'orange', text: 'Orange'},
          {value: 'deep-orange', text: 'Deep Orange'},
          {value: 'blue-grey', text: 'Blue Grey'},
          {value: 'grey', text: 'Grey'},
          {value: 'black', text: 'Black'},
          {value: 'white', text: 'White'},
          {value: 'transparent', text: 'Transparent'},
        ],
        itemValue: 'value',
        value: 'blue',
        items: [],
        item: {data: [], headers: []},
        wait: false
    },
    toolbarThemeOpacity: {
        label: 'Opacity',
        class: 'xs6',
        type: 'select',
        source: 'parameters.toolbarThemeOpacity.opacity',
        itemText: 'text',
        opacity: [
          {value: '', text: 'None'},
          {value: 'lighten-5', text: 'Lighten 5'},
          {value: 'lighten-4', text: 'Lighten 4'},
          {value: 'lighten-3', text: 'Lighten 3'},
          {value: 'lighten-2', text: 'Lighten 2'},
          {value: 'lighten-1', text: 'Lighten 1'}
        ],
        itemValue: 'value',
        value: '',
        items: [],
        item: {data: [], headers: []},
        wait: false
    },
    title: {
        label: 'Title',
        source: 'parameters.never',
        items: [],
        types: [],
        class: 'xs12 sm12 d-flex',
        type: 'input',
        value: undefined,
        display: true,
        wait: false
    },
    searchPlaceholder: {
        label: 'Search Placeholder',
        source: 'parameters.never',
        items: [],
        types: [],
        class: 'xs12 sm12 d-flex',
        type: 'input',
        value: undefined,
        display: true,
        wait: false
    },
    displaySparklineSource: {
        label: 'Display line chart',
        class: 'xs12 xs12',
        type: 'switch',
        source: 'parameters.formatSource.aggregates',
        itemValue: 'format',
        value: true,
        items: [],
        item: {data: [], headers: []}
    },
    filterSource: {
        label: 'Active Filter',
        class: 'xs12 xs12',
        type: 'switch',
        source: 'parameters.formatSource.aggregates',
        itemValue: 'format',
        value: true,
        items: [],
        item: {data: [], headers: []}
    },
    themeDataSource: {
        label: 'Theme',
        class: 'xs12 sm12 d-flex',
        type: 'select',
        source: 'dataSources',
        itemText: 'name',
        itemValue: 'id',
        items: [],
        wait: false
    },
    colorGradient: {
        label: 'ThemeColor',
        class: 'xs12 sm12 d-flex',
        type: 'theme-color',
        source: 'parameters.themeDataSource.item.data',
        itemText: 'name',
        itemValue: 'id',
        item: {},
        items: [],
        wait: true,
        value: null
    },
    lineColorDataSource: {
        label: 'Line Color',
        class: 'xs12 sm12 d-flex',
        type: 'select',
        source: 'dataSources',
        itemText: 'name',
        itemValue: 'id',
        items: [],
        wait: true
    },
    lineColorGradient: {
        label: 'LineColor',
        class: 'xs12 sm12 d-flex',
        type: 'theme-color',
        source: 'parameters.lineColorDataSource.item.data',
        itemText: 'name',
        itemValue: 'id',
        item: {},
        items: [],
        wait: true,
        value: null
    }
};

export default parameters;
